<!--融资事件-->
<template>
  <div class="financing-container">
    <div class="financing-content">
      <div class="financing-search-menu">
        <span>搜索到<span style="color: #fe273b">{{ tablePage.total > 5000 ? '5000+' : tablePage.total }}</span>个结果</span>
        <div class="financing-search-right">
          <el-cascader v-model="region" placeholder="全国" :options="regionItem" @change="changeRegion"
                       :show-all-levels="false" style="width: 120px;margin-right: 10px" clearable></el-cascader>
          <el-cascader v-model="industry" placeholder="行业" :options="industryItem" @change="changeIndustry"
                       :show-all-levels="false" style="width: 120px;margin-right: 10px" clearable></el-cascader>
          <el-date-picker v-model="year" value-format="yyyy" type="year" class="financing-date" placeholder="日期"
                          style="width: 140px;margin-right: 10px"/>
          <el-input placeholder="请输入投资机构、企业名称" v-model="keyword" class="keyword-input" style="width: 345px"
                    @keyup.enter.native="getFinancingInfo">
            <el-button type="danger" slot="append" @click="getFinancingInfo">搜索</el-button>
          </el-input>
        </div>
      </div>
      <div class="financing-table">
        <vxe-table :height="Theight" stripe border align="center" :data="financingInfo"
                   :column-config="{resizable: true}"
                   :header-cell-style="{backgroundColor: '#F4F5FD',color: '#333333'}">
          <vxe-column field="companyName" title="企业名称">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="enterpriseDetails(row)">{{ row.companyName }}</el-link>
            </template>
          </vxe-column>
          <vxe-column field="investor" title="投资机构"/>
          <vxe-column field="financingType" title="融资阶段"/>
          <!--<vxe-column field="stockName" title="交易所名称"/>-->
          <vxe-column field="money" title="融资金额"/>
          <vxe-column field="financingName" title="融资时间" width="120">
            <template #default="{ row }">
              <span>{{ row.financingName | formatDate}}</span>
            </template>
          </vxe-column>
        </vxe-table>
        <div style="padding:10px 10px 0px;">
          <page :total="tablePage.total" @currentPage="currentPage" :limit="tablePage.pageSize" style="float: right;"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';
import page from "@/components/page/pages";
import cityJson from "@/static/cityJson.json";
import cityJsonList from '@/static/city2.json';
import {getIndustry,financingEventsList} from '@/api/enterprise_searchApi'
import {formatDate} from "@/common/formatDate";
Vue.use(VXETable)
export default {
  name: "financing",
  components: {page},
  filters: {
    formatDate(time) {
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd')
    }
  },
  data() {
    return {
      region: [],
      industry: '',
      industryItem: [],
      regionItem: cityJsonList,
      financingInfo: [],
      cityList: {},
      industryThreeId:0,
      queryAllCityType: 0,
      year: '',
      keyword: '',
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      Theight: document.documentElement.clientHeight - 477
    }
  },
  watch: {
    year(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getFinancingInfo();
      }
    },
    region(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getFinancingInfo();
      }
    },
    industry(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getFinancingInfo();
      }
    },
  },
  methods: {
    /*获取融资事件信息*/
    getFinancingInfo() {
      financingEventsList({
        cityCode: this.region[1],
        industryThreeId: this.industryThreeId,
        keyword: this.keyword,
        page: this.tablePage.currentPage,
        pageLimit: this.tablePage.pageSize,
        status: '',
        year: this.year || 0,
      }).then(res=>{
        if (res.code==200){
          this.tablePage.total = parseInt(res.content.total);
          this.financingInfo = res.content.rows;
          console.log(res);
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getFinancingInfo();
    },
    /*监听地区修改*/
    changeRegion(value) {
      if (value[0] == value[1]) {
        this.queryAllCityType = 0;
      } else if (value[1] == 110100 || value[1] == 120100 || value[1] == 500100 || value[1] == 310100) {
        this.queryAllCityType = 0;
      } else {
        this.queryAllCityType = 1;
      }
    },
    /*获取行业类别*/
    getIndustryItem(){
      getIndustry().then(res=>{
        if (res.code==200){
          console.log(res.content);
          for (let list of res.content) {
            let item = {}
            if (list.children!=undefined && list.children.length>0){
              item = {value: list.rid, label: list.name, children: []}
              for (let son of list.children) {
                let son_list = {value: son.rid, label: son.name}
                item.children.push(son_list);
              }
            }else{
              item = {value: list.rid, label: list.name}
            }
            this.industryItem.push(item);
          }
        }
      })
    },
    /*监听行业修改*/
    changeIndustry(value){
      if (value.length>1){
        this.industryThreeId=value[1];
      }else if (value.length==1){
        this.industryThreeId=value[0];
      }else{
        this.industryThreeId=0;
      }
      console.log(this.industryThreeId);
    },
    /*查看企业详情*/
    enterpriseDetails(row){
      let routeData = this.$router.resolve({
        name: "enterpriseDetails",
        path: '/enterpriseDetails/index',
        query: {id:row.cid}
      });
      window.open(routeData.href, '_blank')
    }
  },
  mounted() {
    this.getIndustryItem();
    this.getFinancingInfo();
  },
  beforeMount() {
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
      this.region = [this.cityList.id, this.cityList.vid];
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name) {
          this.cityList = li;
          this.region = [li.id, li.vid];
        }
      }
    }
  }
}
</script>
<style scoped>
.financing-container >>> .financing-content .financing-search-menu .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}

.financing-container >>> .financing-content .financing-search-menu input::-webkit-input-placeholder {
  color: #999999;

}

.financing-container >>> .financing-content .financing-search-menu .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}

.financing-container >>> .financing-content .financing-search-menu .el-icon-search {
  font-size: 19px;
}

.financing-container >>> .financing-content .financing-search-menu .el-input-group__append,
.financing-container >>> .financing-content .financing-search-menu .el-input-group__prepend {
  background-color: #FE273B;
  color: #fff;
  border: 1px solid #FE273B;
  border-radius: 0px 6px 6px 0px;
  padding: 0 20px;
}

.financing-container >>> .financing-content .financing-search-menu .financing-date .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding: 0 40px;
}

.financing-container >>> .financing-content .financing-search-menu .keyword-input .el-input__inner {
  background-color: #ffffff;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  border-radius: 6px 0px 0px 6px;
  border-right: none;
}

.financing-container >>> .financing-content .el-link.el-link--primary {
  color: #1637FF;
}
</style>
<style scoped lang="scss">
.financing-container {
  .financing-content {
    .financing-search-menu {
      padding: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #EBEDF6;
    }

    .financing-table {
      padding: 20px;
    }
  }
}
</style>